import { get } from './request';
import { cfg } from '../config/config';
import { AppStatus } from '../entity/status';

export const getAppStatus = () =>
  get<AppStatus>(`${cfg.apiUrl}/api/status`, AppStatus);
